import moment from "moment";

export const formatEndDate = (date: Date | undefined | null) => {
  if (date !== undefined && date !== null) {
    return moment(date).add(23, "hours").add(59, "minutes").add(59, "seconds");
  }
  return null;
};

export function formatDate(date: Date | null | undefined): Date | null {
  // Usar os componentes da data local (ano, mês, dia) para criar uma nova data em UTC.
  // Isso evita problemas de conversão de fuso horário que o .toISOString() pode causar.
  if (date !== undefined && date !== null) {
    const d = date instanceof Date ? date : new Date(date);
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    return new Date(year, month, day, 12, 0, 0, 0);
  }
  return null;
}
